var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Layout',{attrs:{"resize":_vm.resize,"splits":_vm.splits}},[_c('bd-aside',{staticClass:"custom-drag"}),_c('bd-main',{staticClass:"custom-drag"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }